<template>
  <AsyncPage
    :loader="useSellPartLoader"
    :page-component="SellPart"
  />
</template>

<script setup lang="ts">
import { defineAsyncComponent } from "vue";
import { useSellPartLoader } from "./SellPart.loader.ts";
import { AsyncPage } from "@saflib/vue/components";
const SellPart = defineAsyncComponent(
  () => import("./SellPart.vue"),
);
</script>
